export enum PharmacySchedule {
  Irregular = 'Irregular',
  Regular = 'Regular',
}

